"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ArrowleftIcon = require("@atlaskit/icon/glyph/arrow-left").default;
const { AkCustomDrawer } = require("@atlaskit/navigation");
const react_router_dom_1 = require("react-router-dom");
const drawer_context_1 = require("./drawer-context");
const icon_1 = require("../icon");
const utilities_1 = require("../utilities");
class CustomDrawerView extends React.Component {
    render() {
        return (React.createElement(drawer_context_1.DrawerContextConsumer, null, drawerContext => (React.createElement(AkCustomDrawer, { backIcon: React.createElement(ArrowleftIcon, { label: "Back icon", size: "medium" }), width: this.props.width || "full", isOpen: drawerContext.openDrawer === this.props.id, onBackButton: () => {
                if (this.props.onCloseDrawer) {
                    this.props.onCloseDrawer();
                }
                drawerContext.updateOpenDrawer(null);
            }, primaryIcon: React.createElement(icon_1.MicroscopeIcon, { label: "MicroscopeIcon", size: "large", onClick: () => {
                    drawerContext.updateOpenDrawer(null);
                    this.props.history.push("/");
                } }) }, this.props.children))));
    }
}
exports.CustomDrawerView = CustomDrawerView;
exports.CustomDrawer = utilities_1.compose(react_router_dom_1.withRouter)(CustomDrawerView);
exports.CustomDrawer.displayName = "CustomDrawer";
